/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_1_CInputs */

const en_mk_how_1_c = /** @type {(inputs: Mk_How_1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review your requirements before building`)
};

const id_mk_how_1_c = /** @type {(inputs: Mk_How_1_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau dokumen kebutuhan sebelum mulai membangun`)
};

/**
* | output |
* | --- |
* | "Review your requirements before building" |
*
* @param {Mk_How_1_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_1_c = /** @type {((inputs?: Mk_How_1_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_1_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_1_c(inputs)
	return en_mk_how_1_c(inputs)
});